import { useContext, useRef } from 'react';

import { ApplicationContext } from '@App/contexts/Application';
import { SALES_QUALIFIER_LINE_TELEPHONE } from '@Shared/constants';
import { getCallDate, getCallTime } from '@Shared/helpers/callInfo';
import ConfirmationView from '@Views/shared/ConfirmationView';
import EligibilityLayout from '@src/ui/layouts/EligibilityLayout';

const whatHappensNextItems = [
    'Get a recommendation from a qualified mortgage advisor',
    'Add supporting documents',
    'Get approved, and receive your funds',
];

export const LoanPreferencesBookingConfirmationPage = () => {
    const { loading, callDateTime } = useContext(ApplicationContext);

    const date = new Date(callDateTime);

    const callDate = getCallDate(date);
    const callTime = getCallTime(date);

    const saveRef = useRef(null);

    const navigateLink =
        window.innerWidth >= 1024
            ? '/eligibility/loan-preferences/book-call'
            : '/eligibility/loan-preferences/book-call/calendar';

    return (
        <EligibilityLayout
            loading={loading}
            ref={saveRef}
            showTrustbarV2
            phoneNumber={SALES_QUALIFIER_LINE_TELEPHONE}
        >
            <ConfirmationView
                navigateLink={navigateLink}
                whatHappensNextItems={whatHappensNextItems}
                callTime={callTime}
                callDate={callDate}
            />
        </EligibilityLayout>
    );
};
